// import React, { useEffect, useState } from 'react'
// import { graphqlPost } from '../../api/_call'
// import ImageGallery from 'react-image-gallery'
// import 'react-image-gallery/styles/css/image-gallery.css'
// const ProductImageSliderModal = (props) => {
//   const { main_id } = props
//   const [image, setImage] = useState([])
//   const [name, setName] = useState()
//   const [showloader, setShowloader] = useState(true)
//   const getImage = async () => {
//     setShowloader(true);
//     setImage([]);
//     setName('');
//     try {
//       const postdata =
//         `{
//                  ProductImages(product_id:"` +
//         main_id +
//         `") {
//                   image
//                   name
//               }
//       }`
//       let responce = await graphqlPost(postdata, 'App/graphql')
//       if (responce.data) {
//         setShowloader(false);
//         setImage(responce?.data?.ProductImages?.image)
//         setName(responce?.data?.ProductImages?.name)
//       }
//     } catch (err) {
//       console.log(err, 'err')
//     }
//   }
//   useEffect(() => {
//     if (main_id) {
//       getImage()
//     }
//     // eslint-disable-next-line
//   }, [main_id])

//   return (
//     <div
//       className="modal fade common-modal pro-img-modal"
//       id="ProductViewModal"
//       tabIndex="-1"
//       aria-labelledby="ProductViewModalLabel"
//       aria-hidden="true"
//     >
//       <div className="modal-dialog modal-dialog-centered">
//         <div className="modal-content">
//           <div className="modal-header">
//             <h5 className="modal-title" id="ProductViewModalLabel">
//               {name ? name : ''}
//             </h5>
//             <button
//               type="button"
//               className="btn-close shadow-none"
//               data-bs-dismiss="modal"
//               aria-label="Close"
//             ></button>
//           </div>
//           <div className="modal-body">
//             {showloader && <div id="table_loader" className="">
//               <div className="dots">
//                 <span></span>
//                 <span></span>
//                 <span></span>
//               </div>
//             </div>}
//             <ImageGallery
//               items={image}
//               showPlayButton={false}
//               showFullscreenButton={false}
//               infinite={true}
//               disableSwipe={false}
//               disableThumbnailSwipe={false}
//               additionalClass="pro-img-slider"
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default ProductImageSliderModal

import { useLayoutEffect, useRef, useState } from 'react'
import { graphqlPost } from '../../api/_call'
import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'

const ProductImageSliderModal = (props) => {
  const { main_id } = props
  const [image, setImage] = useState([])
  const [name, setName] = useState('')
  const [showloader, setShowloader] = useState(true)
  const modalInstanceRef = useRef(null)
  const skipNextShowFetchRef = useRef(false)

  const getImage = async () => {
    setShowloader(true)
    setImage([])
    setName('')
    try {
      const postdata = `{
        ProductImages(product_id:"${main_id}") {
          image
          name
        }
      }`
      const responce = await graphqlPost(postdata, 'App/graphql')
      if (responce.data) {
        setShowloader(false)
        setImage(responce?.data?.ProductImages?.image)
        setName(responce?.data?.ProductImages?.name)
      }
    } catch (err) {
      console.log(err, 'err')
    }
  }

  useLayoutEffect(() => {
    if (!main_id) return

    const modalEl = document.getElementById('ProductViewModal')
    if (!modalEl) return

    if (!modalInstanceRef.current) {
      // Some callers render a trigger with data-bs-toggle="modal" (letting
      // Bootstrap's own click handler create/show an instance), others set
      // main_id with no such trigger at all and rely purely on us calling
      // .show() below. Reusing whatever instance already exists (instead
      // of `new Modal(...)`, which would silently replace it) avoids two
      // backdrops stacking up when both paths are in play for the same
      // element — closing the modal would only tear down the second one
      // and leave the first orphaned (stuck grey overlay / unresponsive
      // page).
      modalInstanceRef.current = window.bootstrap.Modal.getOrCreateInstance(modalEl, {
        backdrop: true,
        keyboard: true,
      })
    }

    // Primary, reliable path: fetch directly whenever main_id changes.
    // This has no dependency on event timing/ordering at all.
    getImage()

    // Supplementary path: also refetch on a `show.bs.modal` that happens
    // independently of the .show() call below — e.g. a trigger element's
    // own data-bs-toggle reopening the *same* product after the modal was
    // closed. main_id doesn't change in React's eyes in that case, so this
    // effect wouldn't otherwise rerun and the loader would stay stuck from
    // the previous close. skipNextShowFetchRef distinguishes that case from
    // our own .show() call below firing this same event synchronously
    // (which would otherwise double the fetch we just did above).
    const handleShow = () => {
      if (skipNextShowFetchRef.current) {
        skipNextShowFetchRef.current = false
        return
      }
      getImage()
    }
    const handleHidden = () => {
      setImage([])
      setName('')
      setShowloader(true)
    }

    modalEl.addEventListener('show.bs.modal', handleShow)
    modalEl.addEventListener('hidden.bs.modal', handleHidden)

    skipNextShowFetchRef.current = true
    modalInstanceRef.current.show()
    // .show() is a no-op (doesn't fire show.bs.modal) if the modal is
    // already shown — reset here so a stale `true` can't suppress a later,
    // genuinely independent show.bs.modal.
    skipNextShowFetchRef.current = false

    return () => {
      modalEl.removeEventListener('show.bs.modal', handleShow)
      modalEl.removeEventListener('hidden.bs.modal', handleHidden)
    }
  }, [main_id])

  return (
    <div
      className="modal fade common-modal pro-img-modal"
      id="ProductViewModal"
      tabIndex="-1"
      aria-labelledby="ProductViewModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="ProductViewModalLabel">
              {name || ''}
            </h5>
            <button
              type="button"
              className="btn-close shadow-none"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            {showloader && (
              <div id="table_loader">
                <div className="dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            )}
            {!showloader && (
              <ImageGallery
                items={image}
                showPlayButton={false}
                showFullscreenButton={false}
                infinite={true}
                disableSwipe={false}
                disableThumbnailSwipe={false}
                additionalClass="pro-img-slider"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductImageSliderModal